const convertToArray = function convertObjectToArray(obj) {
  return Object.keys(obj)
    .filter(key => typeof obj[key] === 'object')
    .map(key => {
      const newObj = obj[key];
      newObj.key = key;
      return newObj;
    });
};

export default convertToArray;
